<template>
  <div class="zj-onemap-infopanel">
    <el-row type="flex" justify="space-between">
      <el-col class="seq" :span="3">
        <div>{{info.index}}</div>
      </el-col>
      <el-col :span="21" class="zj-onemap-infopanel-detail">
        <el-row type="flex" justify="space-between">
          <label class="name">{{info.name || info.teamName}}</label>
          <el-button @click.stop="showDetail" class="detail-btn">查看详情</el-button>
        </el-row>
        <el-row>
          <label>联系人:</label>
          <label class="contact">{{info.responsiblePerson || info.contacts}}</label>
          <label class="phone">{{info.mobileNo || info.contactNo}}</label>
        </el-row>
        <el-row type="flex" justify="space-between" :gutter="20">
          <el-col :span="12">
            <el-row>
              <div class="distance">
                <label>{{this.convertDistance(info.distance)}}</label>
              </div>
            </el-row>
            <el-row>
              <label>{{info.address}}</label>
            </el-row>
          </el-col>
          <el-col v-if="isMaterial" class="detail-list-btn-col" :span="12">
            <el-button
              @click.stop="showinventoryList"
              class="detail-list-btn"
            >物资清单 (共{{info.materialTypesCount}}种)</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "ZJComponent-InfoPanel",
  props: {
    info: {
     type: Object,
      default: () => {}
    },
    isMaterial: {
      type: Boolean,
      default: false
    },
    type: {
      required: true,
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    getQuery() {
      var result = {
        id: this.info.id,
        type: "search",
        category: this.type
      };
      return result;
    },
    showinventoryList() {
      console.log("this.info")
      console.log(this.info)
      this.dispatch("ZjEmergencyOneMap", "showinventoryList", this.getQuery());
      this.dispatch(
        "ZjEmergencyOperations",
        "showinventoryList",
        this.getQuery()
      );
    },
    showDetail() {
      this.dispatch("ZjEmergencyOneMap", "showRecordDetail", this.getQuery());
      this.dispatch(
        "ZjEmergencyOperations",
        "showRecordDetail",
        this.getQuery()
      );
    },
    convertDistance(distance) {
      if (distance < 1000) {
        return Math.round(distance * 100) / 100 + "m";
      } else {
        return Math.round((distance / 1000) * 100) / 100 + "km";
      }
    }
  }
};
</script>

<style>
</style>